module.exports = __webpack_public_path__ + "static/img/CgoRDGORkquAAjbxAAQIGmqivEQ747.9ad7084.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGORkquAAjbxAAQIGmqivEQ747.jpg
// module id = Sm5p
// module chunks = 73